import React, { Component } from "react"
import styled from "styled-components"
import ZoomLogo from "../../../images/zoom-logo.png"
import { appStrings } from "../../../common/strings/app_strings"
import { colors } from "../../../common/colors/app_colors"
import { ZoomSubtext } from "./zoom_subtext"
import { makeToast } from "../../../util/toast_util"
import { ZoomConfigForm } from "./zoom_config_form"
import { ZOOM_INTEGRATION_URL } from "../../../common/constants/app_consts"

const {
    zoomHeader,
    zoomAddNew,
    edit,
    cancel,
    selectTeamWarning,
    zoomOverview,
    connectToZoom,
} = appStrings.connectedApps

const { borderGray } = colors

export class ZoomItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pendingConfigFormOpen: false,
        }
    }
    componentDidUpdate(prevProps) {
        // if newly selected config, close pending config form
        if (!prevProps.selected && this.props.selected) {
            this.setState({ pendingConfigFormOpen: false })
        }
    }

    componentWillUnmount() {
        if (this.state.pendingConfigFormOpen) {
            this.setState({ pendingConfigFormOpen: false })
        }
    }

    startZoomOauth = () => {
        const { pendingConfigTeamId, handleStartZoomOauth } = this.props
        // only start oauth if there is a pending team
        if (pendingConfigTeamId) {
            handleStartZoomOauth(pendingConfigTeamId)
            return
        }
        makeToast(selectTeamWarning, "warning")
    }

    subtextConditionalRender = (config, team) => {
        const { selected } = this.props
        const configIsSelected = config && config.id === selected
        const teamName = team ? `🔗${team.isPersonal ? `${team.teamOwnerName} (you)` : team.name}` : ""

        if (this.state.pendingConfigFormOpen) {
            return (
                <ZoomSubtext
                    link={cancel}
                    clickFunction={this.handleHidePendingConfigForm}
                    arrowDirection={"up"}
                />
            )
        }
        if (!config) {
            return (
                <ZoomSubtext
                    link={zoomAddNew}
                    clickFunction={this.handleShowPendingConfigForm}
                />
            )
        }
        if (configIsSelected) {
            return (
                <ZoomSubtext
                    clickFunction={() => this.handleSetSelectedConfigId(null)}
                    arrowDirection={"up"}
                    teamName={teamName}
                />
            )
        }
        if (config) {
            return (
                <ZoomSubtext
                    link={edit}
                    clickFunction={() =>
                        this.handleSetSelectedConfigId(config.id)
                    }
                    arrowDirection={"down"}
                    teamName={teamName}
                />
            )
        }
    }

    handleSetSelectedConfigId = id => {
        this.props.handleSelectZoomConfig(id)
    }
    handleShowPendingConfigForm = () => {
        this.setState({ pendingConfigFormOpen: true })
        this.props.handleSelectZoomConfig(null)
    }
    handleHidePendingConfigForm = () => {
        this.setState({ pendingConfigFormOpen: false })
    }
    selectCalendar = ({ calendar }) => {
        const { id, gCalendarAccountId } = calendar
        const { handleAddNewCalendar, config } = this.props
        handleAddNewCalendar(config.id, gCalendarAccountId, id)
    }

    render() {
        const {
            config,
            team,
            selected,
            pendingConfigTeamId,
            handleStartZoomOauth,
            handleDeleteConfig,
        } = this.props
        const configIsSelected = config && selected === config.id
        const { pendingConfigFormOpen } = this.state
        return (
            <ItemWrapper>
                <Item>
                    <img src={ZoomLogo} alt="Zoom Logo" />
                    <span className="title vertical-align">
                        {zoomHeader}
                    </span>
                    {this.subtextConditionalRender(config, team)}
                </Item>
                {(pendingConfigFormOpen && !selected) && (
                    <div className="connected-apps-item-form-wrapper">
                        <div className="pending-config-group">
                            <p>
                                {zoomOverview}
                                To learn more, click <a
                                    className="a-button"
                                    href={ZOOM_INTEGRATION_URL}
                                    target="_blank">here.</a>
                            </p>
                        </div>

                        {pendingConfigTeamId && (
                            <ConnectToZoomWrapper>
                                <span className={'link'} onClick={this.startZoomOauth}>{connectToZoom}</span>.
                            </ConnectToZoomWrapper>
                        )}
                    </div>
                )}
                {configIsSelected && (
                    <div className="connected-apps-item-form-wrapper">
                        <ZoomConfigForm
                            googleAccounts={config.gCalendarAccounts}
                            config={config}
                            teamName={`🔗${team.isPersonal ? `${team.teamOwnerName} (you)` : team.name}`}
                            handleStartZoomOauth={handleStartZoomOauth}
                            handleDeleteConfig={handleDeleteConfig}
                            selectCalendar={this.selectCalendar}
                        />
                    </div>
                )}
            </ItemWrapper>
        )
    }
}

const ConnectToZoomWrapper = styled.div`
    padding-top: 18px;
`

const ItemWrapper = styled.div`
    border: 1px solid ${borderGray};
    margin: 0px 20px;
    border-radius: 4px;
    margin-bottom: 10px;
    .connected-apps-item-form-wrapper {
        border-top: 1px solid ${borderGray};
        padding: 2rem;
        .pending-config-group {
            display: flex;
            justify-content: space-between;
            .google-link {
                width: 200px;
                text-align: right;
            }
        }
    }
    img {
        height: 35px;
        width: 35px;
    }
`
const Item = styled.div`
    border-radius: 4px;
    display: flex;
    justify: center;
    padding: 10px 20px;
    .title {
        padding-left: 10px;
    }
    .vertical-align {
        margin-top: auto;
        margin-bottom: auto;
    }
    @media (max-width: 425px) {
        .title {
            display: none;
        }
        padding: 10px;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/zoom/zoom_item.jsx